import { render, staticRenderFns } from "./DialogCancelarPlano.vue?vue&type=template&id=010f5f67"
import script from "./DialogCancelarPlano.vue?vue&type=script&lang=js"
export * from "./DialogCancelarPlano.vue?vue&type=script&lang=js"
import style0 from "./DialogCancelarPlano.vue?vue&type=style&index=0&id=010f5f67&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports